/* eslint-disable @typescript-eslint/no-explicit-any */
import Api from '@/plugins/axios';
import { Response } from '@/types/common/Rest';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import { handleApiResponse } from '@/utils/request';
import { IFiltroObras, IObraTempImpressao, PageObras } from '../types';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/publico/obra`;

class ObrasService {
  public async consultarObras(
    filtro: IFiltroObras
  ): Promise<Response<PageObras>> {
    const url = `${BASE_URL}/find/obras/periodicos/artigos`;
    return handleApiResponse(() => Api.post(url, filtro));
  }

  public async consultaObraParaImpressao(
    cdObra: number,
    cdTipoObra: number
  ): Promise<Response<IObraTempImpressao>> {
    const url = `${BASE_URL}/find/${cdTipoObra}/${cdObra}`;
    return handleApiResponse(() => Api.get(url));
  }

  public async consultaCapitulosLivros(
    cdLocalizacaoLivro: number
  ): Promise<Response<any>> {
    const url = `${BASE_URL}/find/capitulos/${cdLocalizacaoLivro}`;
    return handleApiResponse(() => Api.get(url));
  }

  public async consultaListaPeriodicos(
    cdColecaoPeriodicoVolume: number
  ): Promise<Response<any>> {
    const url = `${BASE_URL}/find/artigos/${cdColecaoPeriodicoVolume}`;
    return handleApiResponse(() => Api.get(url));
  }

  public downloadAcordao(cdAcordao: number) {
    const urlRelatorio = `https://esaj.tjsp.jus.br/cjsg/getArquivo.do?cdAcordao=${cdAcordao}&cdForo=0`;
    window.open(urlRelatorio, '_blank');
  }

  public downloadSimplificado(cdBoletinsList: number[]) {
    const urlRelatorio = `/mat-report/publico/gcn/api/v1.0/jurisprudencia?cdBoletinsList=${cdBoletinsList}`;
    window.open(`${urlRelatorio}&formato=S`, '_blank');
  }

  public downloadDetalhado(cdBoletinsList: number[]) {
    const urlRelatorio = `/mat-report/publico/gcn/api/v1.0/jurisprudencia?cdBoletinsList=${cdBoletinsList}`;
    window.open(`${urlRelatorio}&formato=D`, '_blank');
  }
}
export default new ObrasService();
